import Page from "src/layouts/Page";
import ContentTable, {
	ContentTableItem
} from "src/components/ContentTable/ContentTable";
import useContentOrders from "../../hooks/useContentOrders";
import useToggleContentOrderPublished from "../../hooks/useToggleContentOrderPublished";
import useMoveContentOrder from "../../hooks/useMoveContentOrder";
import { mapContentOrdersToContentTableItems } from "../../utils/mapContentOrdersToContentTableItems";

const HomepageOrdering = () => {
	const { data: allOrders = [] } = useContentOrders();

	const { mutate: togglePublished } = useToggleContentOrderPublished();
	const { mutate: moveContentOrder, isLoading: isMoving } =
		useMoveContentOrder();

	const items = mapContentOrdersToContentTableItems(allOrders);

	const handleMove = (item: ContentTableItem, direction: -1 | 1) => {
		if (isMoving) return;
		moveContentOrder({ id: Number(item.id), offset: direction });
	};

	return (
		<Page>
			<ContentTable
				items={items}
				showCreatedBy={false}
				showLastUpdated={false}
				onMakeLive={(item) =>
					togglePublished({
						id: Number(item.id),
						isPublished: true
					})
				}
				onMakeDraft={(item) =>
					togglePublished({
						id: Number(item.id),
						isPublished: false
					})
				}
				onMoveUp={(item) => handleMove(item, -1)}
				onMoveDown={(item) => handleMove(item, 1)}
			/>
		</Page>
	);
};

export default HomepageOrdering;
